import globalVariables from '@/domains/shared/data/globalVariables';
import { BodyR } from '@pensionbee/honeypot-ui';

const GENERAL_ENQUIRIES_PHONE_NUMBER =
  globalVariables.pensionbeeContactPhoneNumber;

export const twoFaFaqItems = [
  {
    id: 'faq-1',
    heading: 'How long will the code last for?',
    content: (
      <BodyR>
        The code will expire five minutes after being sent. If you have trouble
        receiving the code, you can request another one to be sent immediately.
        If the code is entered incorrectly three times, we’ll ask you to give us
        a call on{' '}
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline hover:text-blue-100"
        >
          {' '}
          {GENERAL_ENQUIRIES_PHONE_NUMBER}{' '}
        </a>
      </BodyR>
    ),
  },
  {
    id: 'faq-2',
    heading: 'What happens if I change my mobile number?',
    content: (
      <BodyR>
        To update your mobile number, please email your BeeKeeper from the email
        addressed registered on your PensionBee account. If you no longer have
        access to your registered email, please call us on{' '}
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline hover:text-blue-100"
        >
          {' '}
          {GENERAL_ENQUIRIES_PHONE_NUMBER}{' '}
        </a>
        (Monday–Friday: 9:30am–5pm).
      </BodyR>
    ),
  },
  {
    id: 'faq-3',
    heading: 'I don’t have access to my mobile right now, how can I log in?',
    content: (
      <BodyR>
        If you can’t log in using SMS verification, please call us on
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline hover:text-blue-100"
        >
          {' '}
          {GENERAL_ENQUIRIES_PHONE_NUMBER}{' '}
        </a>
        (Monday–Friday: 9:30am–5pm).
      </BodyR>
    ),
  },
  {
    id: 'faq-4',
    heading:
      'I’m locked out of my account because I didn’t receive the code or it didn’t work. What should I do next?',
    content: (
      <BodyR>
        If you’re locked out due to issues with the SMS code, please call us on
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline hover:text-blue-100"
        >
          {' '}
          {GENERAL_ENQUIRIES_PHONE_NUMBER}{' '}
        </a>
        (Monday–Friday: 9:30am–5pm).
      </BodyR>
    ),
  },
  {
    id: 'faq-5',
    heading: 'Can I disable two-factor authentication after setting it up?',
    content: (
      <BodyR>
        Yes, but your PensionBee account will become less secure. To disable
        2FA, please call us on
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline hover:text-blue-100"
        >
          {' '}
          {GENERAL_ENQUIRIES_PHONE_NUMBER}{' '}
        </a>
        (Monday–Friday: 9:30am–5pm).
      </BodyR>
    ),
  },
  {
    id: 'faq-6',
    heading:
      'I’m moving abroad, will I still be able to log into my account with 2FA?',
    content: (
      <BodyR>
        Yes, you can use 2FA from anywhere in the world. You can set up 2FA with
        a UK or non-UK mobile number to log in from any country. International
        message rates may apply. If you need help, call us on{' '}
        <a
          href={`tel:${GENERAL_ENQUIRIES_PHONE_NUMBER.replace(/\s+/g, '')}`}
          className="text-blue-100 underline hover:text-blue-100"
        >
          {' '}
          {GENERAL_ENQUIRIES_PHONE_NUMBER}{' '}
        </a>{' '}
        (Monday–Friday: 9:30am–5pm).
      </BodyR>
    ),
  },
];
